import useLang from "@/hooks/useLang";
import translations from "@/translations";

export default function useTranslation() {
    const lang = useLang((state) => state.lang);
    return translations[lang ?? "ar"];
}
